import Moment from "react-moment";
import { dateFormat } from "../constants";
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import { SupervisedUserCircle } from "@material-ui/icons";
import UserSelection from "../pages/components/UserSelection";
import UserDetail from "../pages/user/userDetail";

export const EditCommandCell = (props) => {
  if (props.rowType === "groupHeader") {
    return null;
  }
  return (
    <td>
      <button
        disabled={props.disabled}
        className="k-button k-primary"
        onClick={() => props.enterEdit(props.dataItem)}
      >
        {props.displayName ? props.displayName : props.icon}
      </button>
    </td>
  );
};

export const FullnameCell = (props) => {
  let isAdministrator = false;
  props.dataItem.roles.map((item) => {
    if (item.roleName == "Administrator") {
      isAdministrator = true;
      return item;
    }
    return item;
  });
  if (props.rowType === "groupHeader") {
    return null;
  }
  return (
    <td>
      <label>{props.fullName}</label>
      {isAdministrator && (
        <i
          title={"Administrator"}
          style={{ marginLeft: "10px", marginTop: "5px" }}
        >
          <SupervisedUserCircle />
        </i>
      )}
    </td>
  );
};

export const MomentCommandCell = (props) => {
  if (props.rowType === "groupHeader") {
    return null;
  }
  return (
    <td>
      <Moment format={dateFormat} date={new Date(props.date)} />
    </td>
  );
};
